import { render, staticRenderFns } from "./ClientFatCard.vue?vue&type=template&id=7af8b27d&scoped=true&"
import script from "./ClientFatCard.vue?vue&type=script&lang=js&"
export * from "./ClientFatCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientFatCard.vue?vue&type=style&index=0&id=7af8b27d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af8b27d",
  null
  
)

export default component.exports